<script>
  import TrabalheConoscoService from '../../../../domain/trabalhe-conosco/services/trabalhe-conosco'
  import moment from 'moment'
  import vagas from '../lista-vagas'
  import estadosCivis from '../estados-civis'
  import listaEstados from '../lista-estados'
  import listaEscolaridade from '../escolaridade'

  const possuiExperiencia = [
    {id: 1, nome: 'SIM'},
    {id: 2, nome: 'NÃO'}
  ]

  export default {
    name: 'trabalhe-conosco-detalhes',
    data () {
      return {
        baseUrl: process.env.API_URL + '/uapi/curriculos/' + this.$route.query.id,
        projeto: {}
      }
    },
    computed: {
      vagaDesejada () {
        return vagas.find(vaga => vaga.id === this.projeto.cargo) || 'Não especificado'
      },
      estadoCivil () {
        return estadosCivis.find(item => item.id === this.projeto.estadoCivil) || 'Não especificado'
      },
      estado () {
        const estado = listaEstados.find(estado => estado.sigla === this.projeto.estado)
        return `${estado.nome} (${estado.sigla})`
      },
      escolaridade () {
        return listaEscolaridade.find(item => item.id === this.projeto.escolaridade) || 'Não especificado'
      },
      experiencia () {
        return possuiExperiencia.find(item => item.id === this.projeto.experiencia) || 'Não especificado'
      }
    },
    filters: {
      dataFilter (value) {
        return moment(value).format('L')
      }
    },
    created () {
      console.log('Allons-y!!')
      this.getProjeto()
    },
    methods: {
      getProjeto () {
        this.$loaderOverlay.open()
        this.isLoading = true
        TrabalheConoscoService.getDetalhes(this.$route.query.id)
          .then(result => {
            this.projeto = result.data
            this.isLoading = false
            this.$loaderOverlay.hide()
          })
      },
      deletar () {
        if (confirm('Tem certeza que deseja excluir ?')) {
          this.isLoading = true
          TrabalheConoscoService.deletar(this.projeto.id)
            .then(result => {
              this.$router.push({name: 'trabalhe.conosco.index'})
              this.isLoading = false
            })
            .catch(error => {
              console.log('deu erro', error.response.data.errors)
              alert('erro ao excluir projeto. tente novamente')
              this.isLoading = false
            })
        }
      },
      __gettype (str) {
        const ext = str.toLowerCase().match(/\w{3,4}$/)[0]
        console.log(ext)
        return ext === 'pdf' ? ext : 'word'
      },
      purifyPhone (str) {
        return str.length ? str.replace(/[^0-9]/g, '') : ''
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div class="content-transition">
      <!--btn-status-confirmar :Status="getStatus" ref="confirmarStatus"></btn-status-confirmar-->
      <div class="fade-in-down">
        <div class="bg-light lter b-b wrapper-md">
          <div class="row">
            <div class="col-md-4">
              <h4 class="m-n font-thin h4">Vaga: {{vagaDesejada.nome}}</h4>
              <span class="label no-radius bg-dark"></span>
              <span class="label m-l-n-xxs no-radius bg-success"></span>
            </div>
            <div class="col-md-8">
              <div class="visible-xs m-t-lg"></div>
              <u-button class="btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print"
                        tabindex="1"
                        @click.prevent="deletar">
                <i class="fa fa-edit m-r-xs"></i> Deletar
              </u-button>
              <router-link :to="{name: 'trabalhe.conosco.index'}"
                           class="pull-right pull-none-xs hidden-print m-t-xs m-r"
                           style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
              </router-link>
            </div>
          </div>
        </div>
        <div class="wrapper-md">

          <div class="row">
            <div class="col-xs-4 col-md-4">
              <p>
                Nome: <strong>{{projeto.nome}}</strong> <br>
                E-mail: <strong>{{projeto.email}}</strong> <br>
                CPF: <strong>{{projeto.cpf | formataCpf}}</strong> <br>
                Data de Nascimento: <strong>{{projeto.nascimento}}</strong> <br>
                Estado Civil: <strong>{{estadoCivil.nome}}</strong> <br>
                Escolaridade: <strong>{{escolaridade.nome}}</strong><br>
                Possui experiência? <strong>{{experiencia.nome}}</strong>
              </p>
            </div>

            <div class="col-xs-3 col-md-3">
              <p>
                CEP: <strong>{{projeto.cep | formataCep}}</strong><br>
                Endereço: <strong>{{projeto.endereco}}</strong><br>
                Bairro: <strong>{{projeto.bairro}}</strong><br>
                Cidade: <strong>{{projeto.cidade}}</strong><br>
                Estado: <strong>{{estado}}</strong>
              </p>
            </div>

            <div class="col-xs-3 col-md-3">
              <p>
                Telefone: <strong>{{projeto.telefone | formataTelefone}}</strong><br>
                Celular: <strong>{{projeto.celular | formataTelefone}}</strong>
              </p>
            </div>
            <div class="col-xs-2 col-md-2">
              <div class="fotos-flex">
                <div class="foto">
                  <a target="_blank"><i :class="`fa fa-file-${__gettype(projeto.anexo)}-o fa-5x`"></i></a>
                  <div style="margin-top: 5px;">
                    <a :href="baseUrl" class="btn btn-xs btn-block btn-success" target="_blank"><i class="fa fa-eye"></i> Ver currículo</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-12 m-t">
              <strong>Informações Complementares</strong>
              <div class="projetoText">{{ projeto.complementares }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .projetoText {
    white-space: pre-wrap;
    display: block;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// Detalhes.vue?5b12fd50